import { Text } from "@theme/components";

interface FooterCopyrightProps {
  currentYear: number;
  allRightsReserved: string;
}

export const FooterCopyright = ({ currentYear, allRightsReserved }: FooterCopyrightProps) => (
  <Text
    variant="sansMicro02Regular"
    sx={{
      color: "grey300",
      order: ["2", null, "1"],
    }}
  >
    Copyright © {currentYear}, Manscaped. {allRightsReserved}
  </Text>
);
